import { Bold as OriginalBold } from 'element-tiptap'
import CustomBoldMenuButton from './MenuButton'

export default class Ai extends OriginalBold {
  get name() {
    return 'ai'
  }
  
  menuBtnView ({ isActive, commands, focus, editor }) {
    return {
      component: CustomBoldMenuButton,
      componentProps: {
        isActive: false // AI助手不需要激活状态
      },
      componentEvents: {
        click: async (callback) => {
          const selection = window.getSelection()
          const selectedText = selection.toString().trim()
          
          // 如果没有选中文本，提示用户
          if (!selectedText) {
            callback && callback('请先选中要分析的文本')
            return
          }
          
          // 调用原始的AI功能：分析选中文本的含义和理解
          callback && callback(selectedText)
        }
      }
    }
  }
}
